module.exports = __webpack_public_path__ + "img/template.d63432e2.svg";